import PropTypes from 'prop-types';
import React, { useState } from 'react';
import Image from 'next/image';
import ChevronLeftNav from 'pubweb-smokey/dist/images/svg/iconography-16x16/chevron-lft.svg';
import ChevronRightSvg from 'pubweb-smokey/dist/images/svg/iconography-16x16/chevron-right.svg';
import { formatDate, truncateText } from '@utils/formatters';
import { FeaturedArticlesStyles } from './FeaturedArticles.styled';
import { prefixRoute } from '@utils/newsroomUtils';
import { formatHttpsUrl } from '@utils/utils';

const FeaturedArticles = ({ featuredArticles }) => {
  const [selectedArticle, setSelectedArticle] = useState(featuredArticles[0]);

  const previousArticle = () => {
    const articleIndex = featuredArticles.indexOf(selectedArticle);

    if (articleIndex === 0) {
      setSelectedArticle(featuredArticles[featuredArticles.length - 1]);
    } else {
      setSelectedArticle(featuredArticles[articleIndex - 1]);
    }
  };

  const nextArticle = () => {
    const articleIndex = featuredArticles.indexOf(selectedArticle);
    if (articleIndex === featuredArticles.length - 1) {
      setSelectedArticle(featuredArticles[0]);
    } else {
      setSelectedArticle(featuredArticles[articleIndex + 1]);
    }
  };

  return (
    <FeaturedArticlesStyles>
      <div className="featured-articles-media">
        <a
          href={prefixRoute(selectedArticle.slug)}
          className={`gtm-featured-article-${
            featuredArticles.indexOf(selectedArticle) + 1
          }`}
          target="_blank"
          rel="noreferrer"
        >
          {selectedArticle?.featuredMedia?.media?.url && (
            <Image
              src={formatHttpsUrl(
                selectedArticle.featuredMedia.media.url + '?h=550&fm=webp'
              )}
              alt={selectedArticle.featuredMedia.altText}
              width={630}
              height={550}
            />
          )}
          {selectedArticle.featuredMediaTitle && (
            <h2 className="featured-media-title">
              {selectedArticle.featuredMediaTitle}
            </h2>
          )}
        </a>
      </div>
      <div className="featured-articles-cards">
        {featuredArticles &&
          featuredArticles.map((featuredArticle, index) => {
            return (
              <a
                href={prefixRoute(featuredArticle.slug)}
                target="_blank"
                rel="noreferrer"
                onMouseOver={() => setSelectedArticle(featuredArticle)}
                key={`featured-article-${index}`}
                className={`gtm-featured-article-${index + 1} ${
                  featuredArticle == selectedArticle ? 'selected' : ''
                }`}
              >
                <h6>{formatDate(featuredArticle.publicationDate)}</h6>
                <h4>{truncateText(featuredArticle.headline, 96)}</h4>
              </a>
            );
          })}
      </div>

      {featuredArticles && featuredArticles.length > 0 && (
        <div className="featured-articles-dots">
          <span onClick={previousArticle} className="navigation">
            <ChevronLeftNav />
          </span>
          {featuredArticles.map((featuredArticle, index) => (
            <div
              onClick={() => setSelectedArticle(featuredArticle)}
              key={`dot-${index}`}
              className={
                featuredArticle == selectedArticle ? 'dot selected' : 'dot'
              }
            ></div>
          ))}
          <span onClick={nextArticle} className="navigation right">
            <ChevronRightSvg />
          </span>
        </div>
      )}
    </FeaturedArticlesStyles>
  );
};

FeaturedArticles.propTypes = {
  featuredArticles: PropTypes.any,
};

export default FeaturedArticles;
